import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './reducer/login/loginReducer';
import userReducer from './reducer/masters/users/user/userReducer';
import roleReducer from './reducer/masters/users/role/roleReducer';
import permissionReducer from './reducer/masters/users/permission/permissionReducer';
import rolePermissionReducer from './reducer/masters/users/rolePermission/rolePermissionReducer';
import uiReducer from './reducer/sidebar/uiReducer';
import loginLogReducer from './reducer/masters/users/loginLog/loginLogReducer';
import companyReducer from './reducer/masters/company/companyReducer';
import categoryGroupReducer from './reducer/masters/styles/categoryGroup/categoryGroupReducer';
import categoryReducer from './reducer/masters/styles/category/categoryReducer';
import subCategoryReducer from './reducer/masters/styles/subCategory/subCategoryReducer';
import collectionReducer from './reducer/masters/styles/collection/collectionReducer';
import subCollectionReducer from './reducer/masters/styles/subCollection/subCollectionReducer';
import sizeReducer from './reducer/masters/styles/size/sizeReducer';
import purityReducer from './reducer/masters/styles/purity/purityReducer';
import caratageReducer from './reducer/masters/styles/caratage/caratageReducer';
import stoneTypeReducer from './reducer/masters/stoneAttribute/stoneType/stoneTypeReducer';
import colorReducer from './reducer/masters/styles/color/colorReducer';
import productTypeReducer from './reducer/masters/styles/productType/productTypeReducer';
import stoneClarityReducer from './reducer/masters/stoneAttribute/stoneClarity/stoneClarityReducer';
import stoneColorReducer from './reducer/masters/stoneAttribute/stoneColor/stoneColorReducer';
import stoneCutReducer from './reducer/masters/stoneAttribute/stoneCut/stoneCutReducer';
import stoneQualityReducer from './reducer/masters/stoneAttribute/stoneQuality/stoneQualityReducer';
import stoneSizeReducer from './reducer/masters/stoneAttribute/stoneSize/stoneSizeReducer';
import sieveSizeReducer from './reducer/masters/stoneAttribute/sieveSize/sieveSizeReducer';
import uomReducer from './reducer/masters/uom/uomReducer';
import metalColorReducer from './reducer/masters/metalPurity/metalColor/metalColorReducer';
import metalTypeReducer from './reducer/masters/metalPurity/metaltype/metalTypeReducer';
import purityConfigurationReducer from './reducer/masters/metalPurity/purityConfiguration/purityConfigurationReducer';
import orderTypeReducer from './reducer/masters/orderType/orderTypeReducer';
import mouldReducer from './reducer/masters/mould/mould/mouldReducer';
import departmentGroupReducer from './reducer/masters/department/departmentGroup/departmentGroupReducer';
import departmentReducer from './reducer/masters/department/department/departmentReducer';
import fgPurityReducer from './reducer/masters/metalPurity/fgPurity/fgPurityReducer';
import routeMasterReducer from './reducer/masters/route/route/routeMasterReducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  login: loginReducer,
  users: userReducer,
  roles: roleReducer,
  permissions: permissionReducer,
  rolePermissions: rolePermissionReducer,
  ui: uiReducer,
  loginLogs: loginLogReducer,
  company: companyReducer,
  categoryGroup: categoryGroupReducer,
  category: categoryReducer,
  subCategory: subCategoryReducer,
  collection: collectionReducer,
  subCollection: subCollectionReducer,
  size: sizeReducer,
  purity: purityReducer,
  caratage: caratageReducer,
  stoneType: stoneTypeReducer,
  color: colorReducer,
  productType: productTypeReducer,
  stoneClarity: stoneClarityReducer,
  stoneColor: stoneColorReducer,
  stoneCut: stoneCutReducer,
  stoneQuality: stoneQualityReducer,
  stoneSize: stoneSizeReducer,
  sieveSize: sieveSizeReducer,
  uom: uomReducer,
  metalColor: metalColorReducer,
  metalType: metalTypeReducer,
  purityConfiguration: purityConfigurationReducer,
  orderType: orderTypeReducer,
  mould: mouldReducer,
  departmentGroup: departmentGroupReducer,
  department: departmentReducer,
  fgPurity: fgPurityReducer,
  routeMaster:routeMasterReducer,
});

export const store = configureStore({
  reducer: rootReducer,
}); 